export const getPreviewMode = (url) => typeof url === "string" ? url.split("/")[1] === "cdp-preview" : false;
